
import React, { useEffect, useState } from 'react';
import { userService } from '../../services/user.service';
import { Trade } from '../../types';
import TradeCard from '../../components/cards/TradeCard';

const TradingsSkeleton = () => (
  <div className="space-y-6 animate-pulse">
    <div className="space-y-2">
      <div className="h-8 w-48 bg-slate-800 rounded-lg"></div>
      <div className="h-4 w-32 bg-slate-800/50 rounded-lg"></div>
    </div>
    <div className="space-y-3">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="h-24 bg-slate-900/40 border border-slate-800 rounded-2xl"></div>
      ))}
    </div>
  </div>
);

const Tradings: React.FC = () => {
  const [trades, setTrades] = useState<Trade[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTrades = async () => {
      try {
        const response = await userService.getTradings();
        // Safely extract array regardless of whether API returns raw array or { data: [] }
        const data = Array.isArray(response) ? response : (response?.data || []);
        setTrades(data);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch trades');
      } finally {
        setLoading(false);
      }
    };
    fetchTrades();
  }, []);

  if (loading) return <TradingsSkeleton />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-black text-white uppercase tracking-tight">Trade Vault</h2>
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest mt-1">Operational History</p>
        </div>
      </div>

      {error && (
        <div className="p-4 bg-red-500/10 border border-red-500/20 text-red-500 rounded-2xl text-sm font-bold">
          {error}
        </div>
      )}

      <div className="space-y-3">
        {Array.isArray(trades) && trades.length > 0 ? (
          trades.map((trade) => <TradeCard key={trade.tdId} trade={trade} />)
        ) : (
          <div className="p-20 text-center bg-slate-900/20 border border-dashed border-slate-800 rounded-3xl">
            <div className="flex flex-col items-center opacity-40">
              <svg className="w-12 h-12 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
              <p className="text-slate-500 font-bold uppercase tracking-widest">No operations recorded</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tradings;
